export const waitForOpenSansFontLoad = (onFinishedLoading) => {
  let attempts = 0;
  let fontLoadTimer;
  const checkFont = () => {
    if (document.fonts?.check('1rem "Open Sans"') || ++attempts >= 30) {
      clearTimeout(fontLoadTimer);
      onFinishedLoading();
    } else {
      fontLoadTimer = setTimeout(checkFont, 100);
    }
  };
  checkFont();
};

export const waitForAssetsLoad = (onFinishedLoading) => {
  const fontPromise = document.fonts?.ready || Promise.resolve();

  const imagePromise = waitForImages();

  Promise.allSettled([fontPromise, imagePromise]).finally(() => {
    onFinishedLoading();
  });
};

const waitForImages = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const elements = Array.from(document.querySelectorAll('*'));
      const imagePromises = [];

      elements.forEach((element) => {
        const style = window.getComputedStyle(element);
        const backgroundImage = style.getPropertyValue('background-image');

        if (backgroundImage && backgroundImage !== 'none') {
          const urlMatch = backgroundImage.match(/url\(["']?([^"')]+)["']?\)/);
          if (urlMatch && urlMatch[1]) {
            const imageUrl = urlMatch[1];
            imagePromises.push(loadImage(imageUrl));
          }
        }
      });

      Promise.allSettled(imagePromises).finally(() => {
        resolve();
      });
    }, 0);
  });
};

const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    img.onload = resolve;
    img.onerror = reject;
  });
};